import React from 'react';
import { hydrateRoot } from 'react-dom/client';

import '../customer_pages/_shelf-category/shelf-category-google-tag-manager';
import '../customer_pages/_shelf-category/shelf-category-omni-analytics';
import ShelfCategorySearch from '../customer_pages/_shelf-category/shelf-category-search';

document.addEventListener('DOMContentLoaded', () => {
  const root = document.getElementById('product-shelf-content');

  const props = JSON.parse(root.dataset.props);

  hydrateRoot(root, <ShelfCategorySearch {...props} />);
});
